import type { FormValues } from "@/widgets/classic-form/form";
import { FieldComposer, fieldToConfig } from "@/features/form-fields";
import { type EventAssertion, type Field } from "@/entities/form-metadata";
import type { PrefixObjectAccessor } from "@/shared/forms";
import styles from "./MonthInput.module.scss";

interface EventGroupMonthInputProps {
    fieldData: Field<EventAssertion>;
    fieldPath: string;
    inputProperties?: React.InputHTMLAttributes<HTMLInputElement>;
}

export const EventGroupMonthInput: React.FC<EventGroupMonthInputProps> = ({
    fieldData,
    fieldPath,
    inputProperties,
}) => (
    <FieldComposer
        fieldPath={`${fieldPath}.date.month` as PrefixObjectAccessor<FormValues, []>}
        fieldConfig={fieldToConfig(fieldData)}
    >
        <FieldComposer.FieldConnector>
            {({ formField, fieldConfig, fieldPath: fieldPathFromComposer }, id) => (
                <FieldComposer.Inputs.LimitedValues
                    id={id}
                    {...inputProperties}
                    value={String(formField.value)}
                    limitedValues={fieldData.features.options!}
                    required={fieldConfig.required}
                    ariaLabel={inputProperties?.["aria-label"] ?? fieldData.label}
                    data-testid={fieldPathFromComposer}
                    ref={formField.ref}
                    className={styles.input}
                    onChange={(e) => {
                        const val = e.target.value;
                        formField.onChange(val !== "" && Number.isFinite(Number(val)) ? Number(val) : null);
                    }}
                />
            )}
        </FieldComposer.FieldConnector>
    </FieldComposer>
);
